import { type ThunkDispatch } from "@reduxjs/toolkit";

import { type ReduxState } from "@dashboard/types/reduxState";
import { type ThunkExtraArgument } from "@dashboard/types/thunk";

import { type ErrorReducerAction } from "../reducers/errorReducer";

/**
 * Helper that returns a function that dispatches an error.
 */
export const addError =
  (
    dispatch: ThunkDispatch<ReduxState, ThunkExtraArgument, ErrorReducerAction>
  ) =>
  (error: Error | string) => {
    if (error instanceof Error) error = error.message;
    dispatch({ type: "ADD_ERROR", payload: error, isUserFacing: false });
  };

export const addUserFacingError =
  (
    dispatch: ThunkDispatch<ReduxState, ThunkExtraArgument, ErrorReducerAction>
  ) =>
  (error: Error | string) => {
    if (error instanceof Error) error = error.message;
    dispatch({ type: "ADD_ERROR", payload: error, isUserFacing: true });
  };
